export const getReservationSuccessLottieData = (hexColor?: string) => {
  const BASE_COLOR_TEXT = '0,1,0.0039';

  const json = {
    nm: 'success',
    ddd: 0,
    h: 600,
    w: 600,
    meta: { g: '@lottiefiles/toolkit-js 0.33.2' },
    layers: [
      {
        ty: 4,
        nm: 'Shape Layer 2',
        sr: 1,
        st: 25,
        op: 50,
        ip: 25,
        hd: false,
        ddd: 0,
        bm: 0,
        hasMask: false,
        ao: 0,
        ks: {
          a: { a: 0, k: [0, 0, 0], ix: 1 },
          s: { a: 0, k: [100, 100, 100], ix: 6 },
          sk: { a: 0, k: 0 },
          p: { a: 0, k: [300, 300, 0], ix: 2 },
          r: { a: 0, k: 0, ix: 10 },
          sa: { a: 0, k: 0 },
          o: { a: 0, k: 100, ix: 11 },
        },
        ef: [],
        shapes: [
          {
            ty: 'gr',
            bm: 0,
            hd: false,
            mn: 'ADBE Vector Group',
            nm: 'Ellipse 1',
            ix: 1,
            cix: 2,
            np: 4,
            it: [
              {
                ty: 'el',
                bm: 0,
                hd: false,
                mn: 'ADBE Vector Shape - Ellipse',
                nm: 'Ellipse Path 1',
                d: 1,
                p: { a: 0, k: [0, 0], ix: 3 },
                s: { a: 0, k: [367.859, 367.859], ix: 2 },
              },
              {
                ty: 'tm',
                bm: 0,
                hd: false,
                mn: 'ADBE Vector Filter - Trim',
                nm: 'Trim Paths 1',
                ix: 2,
                e: {
                  a: 1,
                  k: [
                    {
                      o: { x: 0.829, y: 0 },
                      i: { x: 0.333, y: 1 },
                      s: [0],
                      t: 25,
                    },
                    { s: [100], t: 39 },
                  ],
                  ix: 2,
                },
                o: { a: 0, k: 0, ix: 3 },
                s: {
                  a: 1,
                  k: [
                    { o: { x: 0.333, y: 0 }, i: { x: 0, y: 1 }, s: [0], t: 25 },
                    {
                      o: { x: 0.655, y: 0 },
                      i: { x: 0.089, y: 1 },
                      s: [0],
                      t: 36,
                    },
                    { s: [100], t: 50 },
                  ],
                  ix: 1,
                },
                m: 1,
              },
              {
                ty: 'st',
                bm: 0,
                hd: false,
                mn: 'ADBE Vector Graphic - Stroke',
                nm: 'Stroke 1',
                lc: 1,
                lj: 1,
                ml: 4,
                o: { a: 0, k: 100, ix: 4 },
                w: { a: 0, k: 20, ix: 5 },
                c: { a: 0, k: [0.8941, 0.8941, 0.8941], ix: 3 },
              },
              {
                ty: 'tr',
                a: { a: 0, k: [0, 0], ix: 1 },
                s: { a: 0, k: [100, 100], ix: 3 },
                sk: { a: 0, k: 0, ix: 4 },
                p: { a: 0, k: [1.93, -10.07], ix: 2 },
                r: { a: 0, k: 0, ix: 6 },
                sa: { a: 0, k: 0, ix: 5 },
                o: { a: 0, k: 100, ix: 7 },
              },
            ],
          },
        ],
        ind: 1,
      },
      {
        ty: 4,
        nm: 'Shape Layer 1',
        sr: 1,
        st: 0,
        op: 25,
        ip: 0,
        hd: false,
        ddd: 0,
        bm: 0,
        hasMask: false,
        ao: 0,
        ks: {
          a: { a: 0, k: [0, 0, 0], ix: 1 },
          s: { a: 0, k: [100, 100, 100], ix: 6 },
          sk: { a: 0, k: 0 },
          p: { a: 0, k: [300, 300, 0], ix: 2 },
          r: { a: 0, k: 0, ix: 10 },
          sa: { a: 0, k: 0 },
          o: { a: 0, k: 100, ix: 11 },
        },
        ef: [],
        shapes: [
          {
            ty: 'gr',
            bm: 0,
            hd: false,
            mn: 'ADBE Vector Group',
            nm: 'Ellipse 1',
            ix: 1,
            cix: 2,
            np: 4,
            it: [
              {
                ty: 'el',
                bm: 0,
                hd: false,
                mn: 'ADBE Vector Shape - Ellipse',
                nm: 'Ellipse Path 1',
                d: 1,
                p: { a: 0, k: [0, 0], ix: 3 },
                s: { a: 0, k: [367.859, 367.859], ix: 2 },
              },
              {
                ty: 'tm',
                bm: 0,
                hd: false,
                mn: 'ADBE Vector Filter - Trim',
                nm: 'Trim Paths 1',
                ix: 2,
                e: {
                  a: 1,
                  k: [
                    {
                      o: { x: 0.829, y: 0 },
                      i: { x: 0.333, y: 1 },
                      s: [0],
                      t: 0,
                    },
                    { s: [100], t: 14 },
                  ],
                  ix: 2,
                },
                o: { a: 0, k: 0, ix: 3 },
                s: {
                  a: 1,
                  k: [
                    { o: { x: 0.333, y: 0 }, i: { x: 0, y: 1 }, s: [0], t: 0 },
                    {
                      o: { x: 0.655, y: 0 },
                      i: { x: 0.089, y: 1 },
                      s: [0],
                      t: 11,
                    },
                    { s: [100], t: 25 },
                  ],
                  ix: 1,
                },
                m: 1,
              },
              {
                ty: 'st',
                bm: 0,
                hd: false,
                mn: 'ADBE Vector Graphic - Stroke',
                nm: 'Stroke 1',
                lc: 1,
                lj: 1,
                ml: 4,
                o: { a: 0, k: 100, ix: 4 },
                w: { a: 0, k: 20, ix: 5 },
                c: { a: 0, k: [0.8941, 0.8941, 0.8941], ix: 3 },
              },
              {
                ty: 'tr',
                a: { a: 0, k: [0, 0], ix: 1 },
                s: { a: 0, k: [100, 100], ix: 3 },
                sk: { a: 0, k: 0, ix: 4 },
                p: { a: 0, k: [1.93, -10.07], ix: 2 },
                r: { a: 0, k: 0, ix: 6 },
                sa: { a: 0, k: 0, ix: 5 },
                o: { a: 0, k: 100, ix: 7 },
              },
            ],
          },
        ],
        ind: 2,
      },
      {
        ty: 0,
        nm: 'Pre-comp 1',
        sr: 1,
        st: 54,
        op: 354,
        ip: 54,
        hd: false,
        ddd: 0,
        bm: 0,
        hasMask: false,
        ao: 0,
        ks: {
          a: { a: 0, k: [300, 300, 0], ix: 1 },
          s: {
            a: 1,
            k: [
              {
                o: { x: 0.167, y: 0.167 },
                i: { x: 0.833, y: 0.833 },
                s: [86, 86, 100],
                t: 54,
              },
              { s: [94, 94, 100], t: 62 },
            ],
            ix: 6,
          },
          sk: { a: 0, k: 0 },
          p: { a: 0, k: [300, 300, 0], ix: 2 },
          r: { a: 0, k: 0, ix: 10 },
          sa: { a: 0, k: 0 },
          o: {
            a: 1,
            k: [
              {
                o: { x: 0.167, y: 0.167 },
                i: { x: 0.833, y: 0.833 },
                s: [0],
                t: 54,
              },
              {
                o: { x: 0.167, y: 0.167 },
                i: { x: 0.833, y: 0.833 },
                s: [100],
                t: 56,
              },
              { s: [100], t: 62 },
            ],
            ix: 11,
          },
        },
        ef: [],
        w: 600,
        h: 600,
        refId: 'comp_0',
        ind: 3,
      },
      {
        ty: 4,
        nm: 'Layer 2 Outlines',
        sr: 1,
        st: 54,
        op: 354,
        ip: 54,
        hd: false,
        ddd: 0,
        bm: 0,
        hasMask: false,
        ao: 0,
        ks: {
          a: { a: 0, k: [137.378, 109.309, 0], ix: 1 },
          s: { a: 0, k: [100, 100, 100], ix: 6 },
          sk: { a: 0, k: 0 },
          p: { a: 0, k: [300, 300, 0], ix: 2 },
          r: { a: 0, k: 0, ix: 10 },
          sa: { a: 0, k: 0 },
          o: { a: 0, k: 100, ix: 11 },
        },
        ef: [],
        shapes: [
          {
            ty: 'gr',
            bm: 0,
            hd: false,
            mn: 'ADBE Vector Group',
            nm: 'Group 1',
            ix: 1,
            cix: 2,
            np: 2,
            it: [
              {
                ty: 'sh',
                bm: 0,
                hd: false,
                mn: 'ADBE Vector Shape - Group',
                nm: 'Path 1',
                ix: 1,
                d: 1,
                ks: {
                  a: 0,
                  k: {
                    c: false,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [-84.878, 0.669],
                      [-28.738, 56.809],
                      [84.878, -56.809],
                    ],
                  },
                  ix: 2,
                },
              },
              {
                ty: 'st',
                bm: 0,
                hd: false,
                mn: 'ADBE Vector Graphic - Stroke',
                nm: 'Stroke 1',
                lc: 1,
                lj: 1,
                ml: 10,
                o: { a: 0, k: 100, ix: 4 },
                w: { a: 0, k: 21, ix: 5 },
                c: { a: 0, k: [1, 1, 1], ix: 3 },
              },
              {
                ty: 'tr',
                a: { a: 0, k: [0, 0], ix: 1 },
                s: { a: 0, k: [100, 100], ix: 3 },
                sk: { a: 0, k: 0, ix: 4 },
                p: { a: 0, k: [137.378, 109.308], ix: 2 },
                r: { a: 0, k: 0, ix: 6 },
                sa: { a: 0, k: 0, ix: 5 },
                o: { a: 0, k: 100, ix: 7 },
              },
            ],
          },
          {
            ty: 'tm',
            bm: 0,
            hd: false,
            mn: 'ADBE Vector Filter - Trim',
            nm: 'Trim Paths 1',
            ix: 2,
            e: {
              a: 1,
              k: [
                { o: { x: 0.333, y: 0 }, i: { x: 0.35, y: 1 }, s: [0], t: 54 },
                {
                  o: { x: 0.333, y: 0 },
                  i: { x: 0.032, y: 1 },
                  s: [100],
                  t: 62,
                },
                { s: [94], t: 66 },
              ],
              ix: 2,
            },
            o: { a: 0, k: 0, ix: 3 },
            s: {
              a: 1,
              k: [
                { o: { x: 0.333, y: 0 }, i: { x: 0.185, y: 1 }, s: [0], t: 59 },
                { o: { x: 0.333, y: 0 }, i: { x: 0.306, y: 1 }, s: [6], t: 62 },
                { s: [0], t: 66 },
              ],
              ix: 1,
            },
            m: 1,
          },
        ],
        ind: 4,
      },
      {
        ty: 4,
        nm: 'Layer 1 Outlines',
        sr: 1,
        st: 50,
        op: 350,
        ip: 50,
        hd: false,
        ddd: 0,
        bm: 0,
        hasMask: false,
        ao: 0,
        ks: {
          a: { a: 0, k: [190.878, 189.014, 0], ix: 1 },
          s: {
            a: 1,
            k: [
              {
                o: { x: 0.333, y: 0 },
                i: { x: 0.046, y: 1 },
                s: [0, 0, 100],
                t: 50,
              },
              {
                o: { x: 0.333, y: 0.032 },
                i: { x: 0.019, y: 1 },
                s: [116, 116, 100],
                t: 61,
              },
              { s: [100, 100, 100], t: 67 },
            ],
            ix: 6,
          },
          sk: { a: 0, k: 0 },
          p: { a: 0, k: [299.988, 299.91, 0], ix: 2 },
          r: { a: 0, k: 0, ix: 10 },
          sa: { a: 0, k: 0 },
          o: { a: 0, k: 100, ix: 11 },
        },
        ef: [],
        shapes: [
          {
            ty: 'gr',
            bm: 0,
            hd: false,
            mn: 'ADBE Vector Group',
            nm: 'Group 1',
            ix: 1,
            cix: 2,
            np: 2,
            it: [
              {
                ty: 'sh',
                bm: 0,
                hd: false,
                mn: 'ADBE Vector Shape - Group',
                nm: 'Path 1',
                ix: 1,
                d: 1,
                ks: {
                  a: 0,
                  k: {
                    c: true,
                    i: [
                      [-4.067, -3.573],
                      [0, 0],
                      [-2.665, -0.588],
                      [0, 0],
                      [-1.937, -5.043],
                      [0, 0],
                      [-2.087, -1.753],
                      [0, 0],
                      [0.635, -5.357],
                      [0, 0],
                      [-1.033, -2.517],
                      [0, 0],
                      [3.063, -4.444],
                      [0, 0],
                      [0.259, -2.704],
                      [0, 0],
                      [4.789, -2.513],
                      [0, 0],
                      [1.492, -2.273],
                      [0, 0],
                      [5.418, -0.007],
                      [0, 0],
                      [2.383, -1.32],
                      [0, 0],
                      [4.806, 2.501],
                      [0, 0],
                      [2.727, -0.064],
                      [0, 0],
                      [3.093, 4.437],
                      [0, 0],
                      [2.448, 1.205],
                      [0, 0],
                      [0.67, 5.356],
                      [0, 0],
                      [1.607, 2.198],
                      [0, 0],
                      [-1.904, 5.047],
                      [0, 0],
                      [0.399, 2.689],
                      [0, 0],
                      [-4.043, 3.583],
                      [0, 0],
                      [-0.901, 2.564],
                      [0, 0],
                      [-5.257, 1.298],
                      [0, 0],
                      [-1.995, 1.85],
                      [0, 0],
                      [-5.265, -1.284],
                      [0, 0],
                      [-2.632, 0.713],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [2.049, 1.8],
                      [0, 0],
                      [5.292, 1.166],
                      [0, 0],
                      [0.976, 2.539],
                      [0, 0],
                      [4.146, 3.481],
                      [0, 0],
                      [-0.32, 2.698],
                      [0, 0],
                      [2.05, 4.998],
                      [0, 0],
                      [-1.542, 2.239],
                      [0, 0],
                      [-0.514, 5.372],
                      [0, 0],
                      [-2.412, 1.266],
                      [0, 0],
                      [-2.961, 4.512],
                      [0, 0],
                      [-2.728, 0.003],
                      [0, 0],
                      [-4.73, 2.62],
                      [0, 0],
                      [-2.42, -1.26],
                      [0, 0],
                      [-5.416, 0.129],
                      [0, 0],
                      [-1.557, -2.233],
                      [0, 0],
                      [-4.861, -2.393],
                      [0, 0],
                      [-0.338, -2.697],
                      [0, 0],
                      [-3.192, -4.367],
                      [0, 0],
                      [0.959, -2.542],
                      [0, 0],
                      [-0.792, -5.339],
                      [0, 0],
                      [2.036, -1.805],
                      [0, 0],
                      [1.789, -5.09],
                      [0, 0],
                      [2.647, -0.653],
                      [0, 0],
                      [3.961, -3.674],
                      [0, 0],
                      [2.651, 0.646],
                      [0, 0],
                      [5.226, -1.416],
                    ],
                    v: [
                      [49.728, -183.893],
                      [75.948, -160.861],
                      [83.134, -157.221],
                      [117.251, -149.704],
                      [128.834, -139.758],
                      [141.329, -107.249],
                      [146, -100.704],
                      [172.734, -78.264],
                      [178.36, -64.104],
                      [174.265, -29.568],
                      [175.352, -21.617],
                      [188.578, 10.606],
                      [186.957, 25.734],
                      [167.211, 54.389],
                      [164.465, 61.924],
                      [161.152, 96.546],
                      [152.657, 109.178],
                      [121.785, 125.385],
                      [115.833, 130.78],
                      [96.742, 159.871],
                      [83.317, 167.112],
                      [48.39, 167.159],
                      [40.598, 169.176],
                      [10.101, 186.072],
                      [-5.177, 186.263],
                      [-36.157, 170.138],
                      [-44.005, 168.317],
                      [-78.921, 169.146],
                      [-92.553, 162.244],
                      [-112.489, 133.642],
                      [-118.596, 128.399],
                      [-149.931, 112.972],
                      [-158.793, 100.558],
                      [-163.119, 66.033],
                      [-166.084, 58.567],
                      [-186.661, 30.418],
                      [-188.724, 15.336],
                      [-176.447, -17.206],
                      [-175.593, -25.182],
                      [-180.697, -59.604],
                      [-175.488, -73.898],
                      [-149.422, -97.001],
                      [-144.943, -103.66],
                      [-133.405, -136.47],
                      [-122.117, -146.703],
                      [-88.233, -155.074],
                      [-81.156, -158.891],
                      [-55.62, -182.572],
                      [-40.839, -186.4],
                      [-6.899, -178.12],
                      [1.156, -178.22],
                      [34.84, -187.349],
                    ],
                  },
                  ix: 2,
                },
              },
              {
                ty: 'fl',
                bm: 0,
                hd: false,
                mn: 'ADBE Vector Graphic - Fill',
                nm: 'Fill 1',
                c: { a: 0, k: [0, 1, 0.0039], ix: 4 },
                r: 1,
                o: { a: 0, k: 100, ix: 5 },
              },
              {
                ty: 'tr',
                a: { a: 0, k: [0, 0], ix: 1 },
                s: { a: 0, k: [100, 100], ix: 3 },
                sk: { a: 0, k: 0, ix: 4 },
                p: { a: 0, k: [190.878, 189.015], ix: 2 },
                r: { a: 0, k: 0, ix: 6 },
                sa: { a: 0, k: 0, ix: 5 },
                o: { a: 0, k: 100, ix: 7 },
              },
            ],
          },
        ],
        ind: 5,
      },
    ],
    v: '5.1.7',
    fr: 30,
    op: 69,
    ip: 25,
    assets: [
      {
        nm: '',
        id: 'comp_0',
        layers: [
          {
            ty: 4,
            nm: 'Layer 4 Outlines',
            sr: 1,
            st: 0,
            op: 28,
            ip: 0,
            hd: false,
            ddd: 0,
            bm: 0,
            hasMask: false,
            ao: 0,
            ks: {
              a: { a: 0, k: [26.859, 26.86, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 },
              sk: { a: 0, k: 0 },
              p: { a: 0, k: [115.68, 468.673, 0], ix: 2 },
              r: { a: 0, k: 0, ix: 10 },
              sa: { a: 0, k: 0 },
              o: { a: 0, k: 100, ix: 11 },
            },
            ef: [],
            shapes: [
              {
                ty: 'gr',
                bm: 0,
                hd: false,
                mn: 'ADBE Vector Group',
                nm: 'Group 1',
                ix: 1,
                cix: 2,
                np: 2,
                it: [
                  {
                    ty: 'sh',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Shape - Group',
                    nm: 'Path 1',
                    ix: 1,
                    d: 1,
                    ks: {
                      a: 0,
                      k: {
                        c: false,
                        i: [
                          [0, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                        ],
                        v: [
                          [-20.859, 20.86],
                          [20.859, -20.86],
                        ],
                      },
                      ix: 2,
                    },
                  },
                  {
                    ty: 'st',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Graphic - Stroke',
                    nm: 'Stroke 1',
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 12, ix: 5 },
                    c: { a: 0, k: [0, 1, 0.0039], ix: 3 },
                  },
                  {
                    ty: 'tr',
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    sk: { a: 0, k: 0, ix: 4 },
                    p: { a: 0, k: [26.859, 26.86], ix: 2 },
                    r: { a: 0, k: 0, ix: 6 },
                    sa: { a: 0, k: 0, ix: 5 },
                    o: { a: 0, k: 100, ix: 7 },
                  },
                ],
              },
              {
                ty: 'tm',
                bm: 0,
                hd: false,
                mn: 'ADBE Vector Filter - Trim',
                nm: 'Trim Paths 1',
                ix: 2,
                e: {
                  a: 1,
                  k: [
                    {
                      o: { x: 0.333, y: 0 },
                      i: { x: 0, y: 1 },
                      s: [100],
                      t: 4,
                    },
                    { s: [0], t: 22 },
                  ],
                  ix: 2,
                },
                o: { a: 0, k: 0, ix: 3 },
                s: { a: 0, k: 0, ix: 1 },
                m: 1,
              },
            ],
            ind: 1,
          },
          {
            ty: 4,
            nm: 'Layer 5 Outlines',
            sr: 1,
            st: 0,
            op: 28,
            ip: 0,
            hd: false,
            ddd: 0,
            bm: 0,
            hasMask: false,
            ao: 0,
            ks: {
              a: { a: 0, k: [26.86, 26.859, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 },
              sk: { a: 0, k: 0 },
              p: { a: 0, k: [467.82, 115.827, 0], ix: 2 },
              r: { a: 0, k: 0, ix: 10 },
              sa: { a: 0, k: 0 },
              o: { a: 0, k: 100, ix: 11 },
            },
            ef: [],
            shapes: [
              {
                ty: 'gr',
                bm: 0,
                hd: false,
                mn: 'ADBE Vector Group',
                nm: 'Group 1',
                ix: 1,
                cix: 2,
                np: 2,
                it: [
                  {
                    ty: 'sh',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Shape - Group',
                    nm: 'Path 1',
                    ix: 1,
                    d: 1,
                    ks: {
                      a: 0,
                      k: {
                        c: false,
                        i: [
                          [0, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                        ],
                        v: [
                          [-20.86, 20.859],
                          [20.86, -20.859],
                        ],
                      },
                      ix: 2,
                    },
                  },
                  {
                    ty: 'st',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Graphic - Stroke',
                    nm: 'Stroke 1',
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 12, ix: 5 },
                    c: { a: 0, k: [0, 1, 0.0039], ix: 3 },
                  },
                  {
                    ty: 'tr',
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    sk: { a: 0, k: 0, ix: 4 },
                    p: { a: 0, k: [26.86, 26.859], ix: 2 },
                    r: { a: 0, k: 0, ix: 6 },
                    sa: { a: 0, k: 0, ix: 5 },
                    o: { a: 0, k: 100, ix: 7 },
                  },
                ],
              },
              {
                ty: 'tm',
                bm: 0,
                hd: false,
                mn: 'ADBE Vector Filter - Trim',
                nm: 'Trim Paths 1',
                ix: 2,
                e: { a: 0, k: 100, ix: 2 },
                o: { a: 0, k: 0, ix: 3 },
                s: {
                  a: 1,
                  k: [
                    { o: { x: 0.333, y: 0 }, i: { x: 0, y: 1 }, s: [0], t: 4 },
                    { s: [100], t: 22 },
                  ],
                  ix: 1,
                },
                m: 1,
              },
            ],
            ind: 2,
          },
          {
            ty: 4,
            nm: 'Layer 6 Outlines',
            sr: 1,
            st: 0,
            op: 28,
            ip: 0,
            hd: false,
            ddd: 0,
            bm: 0,
            hasMask: false,
            ao: 0,
            ks: {
              a: { a: 0, k: [26.859, 26.859, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 },
              sk: { a: 0, k: 0 },
              p: { a: 0, k: [115.327, 116.18, 0], ix: 2 },
              r: { a: 0, k: 0, ix: 10 },
              sa: { a: 0, k: 0 },
              o: { a: 0, k: 100, ix: 11 },
            },
            ef: [],
            shapes: [
              {
                ty: 'gr',
                bm: 0,
                hd: false,
                mn: 'ADBE Vector Group',
                nm: 'Group 1',
                ix: 1,
                cix: 2,
                np: 2,
                it: [
                  {
                    ty: 'sh',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Shape - Group',
                    nm: 'Path 1',
                    ix: 1,
                    d: 1,
                    ks: {
                      a: 0,
                      k: {
                        c: false,
                        i: [
                          [0, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                        ],
                        v: [
                          [-20.859, -20.86],
                          [20.859, 20.86],
                        ],
                      },
                      ix: 2,
                    },
                  },
                  {
                    ty: 'st',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Graphic - Stroke',
                    nm: 'Stroke 1',
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 12, ix: 5 },
                    c: { a: 0, k: [0, 1, 0.0039], ix: 3 },
                  },
                  {
                    ty: 'tr',
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    sk: { a: 0, k: 0, ix: 4 },
                    p: { a: 0, k: [26.859, 26.86], ix: 2 },
                    r: { a: 0, k: 0, ix: 6 },
                    sa: { a: 0, k: 0, ix: 5 },
                    o: { a: 0, k: 100, ix: 7 },
                  },
                ],
              },
              {
                ty: 'tm',
                bm: 0,
                hd: false,
                mn: 'ADBE Vector Filter - Trim',
                nm: 'Trim Paths 1',
                ix: 2,
                e: {
                  a: 1,
                  k: [
                    {
                      o: { x: 0.333, y: 0 },
                      i: { x: 0, y: 1 },
                      s: [100],
                      t: 4,
                    },
                    { s: [0], t: 22 },
                  ],
                  ix: 2,
                },
                o: { a: 0, k: 0, ix: 3 },
                s: { a: 0, k: 0, ix: 1 },
                m: 1,
              },
            ],
            ind: 3,
          },
          {
            ty: 4,
            nm: 'Layer 7 Outlines',
            sr: 1,
            st: 0,
            op: 28,
            ip: 0,
            hd: false,
            ddd: 0,
            bm: 0,
            hasMask: false,
            ao: 0,
            ks: {
              a: { a: 0, k: [26.86, 26.86, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 },
              sk: { a: 0, k: 0 },
              p: { a: 0, k: [468.174, 468.32, 0], ix: 2 },
              r: { a: 0, k: 0, ix: 10 },
              sa: { a: 0, k: 0 },
              o: { a: 0, k: 100, ix: 11 },
            },
            ef: [],
            shapes: [
              {
                ty: 'gr',
                bm: 0,
                hd: false,
                mn: 'ADBE Vector Group',
                nm: 'Group 1',
                ix: 1,
                cix: 2,
                np: 2,
                it: [
                  {
                    ty: 'sh',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Shape - Group',
                    nm: 'Path 1',
                    ix: 1,
                    d: 1,
                    ks: {
                      a: 0,
                      k: {
                        c: false,
                        i: [
                          [0, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                        ],
                        v: [
                          [-20.86, -20.86],
                          [20.86, 20.86],
                        ],
                      },
                      ix: 2,
                    },
                  },
                  {
                    ty: 'st',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Graphic - Stroke',
                    nm: 'Stroke 1',
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 12, ix: 5 },
                    c: { a: 0, k: [0, 1, 0.0039], ix: 3 },
                  },
                  {
                    ty: 'tr',
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    sk: { a: 0, k: 0, ix: 4 },
                    p: { a: 0, k: [26.86, 26.86], ix: 2 },
                    r: { a: 0, k: 0, ix: 6 },
                    sa: { a: 0, k: 0, ix: 5 },
                    o: { a: 0, k: 100, ix: 7 },
                  },
                ],
              },
              {
                ty: 'tm',
                bm: 0,
                hd: false,
                mn: 'ADBE Vector Filter - Trim',
                nm: 'Trim Paths 1',
                ix: 2,
                e: { a: 0, k: 100, ix: 2 },
                o: { a: 0, k: 0, ix: 3 },
                s: {
                  a: 1,
                  k: [
                    { o: { x: 0.333, y: 0 }, i: { x: 0, y: 1 }, s: [0], t: 4 },
                    { s: [100], t: 22 },
                  ],
                  ix: 1,
                },
                m: 1,
              },
            ],
            ind: 4,
          },
          {
            ty: 4,
            nm: 'Layer 8 Outlines',
            sr: 1,
            st: 0,
            op: 28,
            ip: 0,
            hd: false,
            ddd: 0,
            bm: 0,
            hasMask: false,
            ao: 0,
            ks: {
              a: { a: 0, k: [35.5, 6, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 },
              sk: { a: 0, k: 0 },
              p: { a: 0, k: [42.5, 292.5, 0], ix: 2 },
              r: { a: 0, k: 0, ix: 10 },
              sa: { a: 0, k: 0 },
              o: { a: 0, k: 100, ix: 11 },
            },
            ef: [],
            shapes: [
              {
                ty: 'gr',
                bm: 0,
                hd: false,
                mn: 'ADBE Vector Group',
                nm: 'Group 1',
                ix: 1,
                cix: 2,
                np: 2,
                it: [
                  {
                    ty: 'sh',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Shape - Group',
                    nm: 'Path 1',
                    ix: 1,
                    d: 1,
                    ks: {
                      a: 0,
                      k: {
                        c: false,
                        i: [
                          [0, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                        ],
                        v: [
                          [6, 6],
                          [65, 6],
                        ],
                      },
                      ix: 2,
                    },
                  },
                  {
                    ty: 'st',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Graphic - Stroke',
                    nm: 'Stroke 1',
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 12, ix: 5 },
                    c: { a: 0, k: [0, 1, 0.0039], ix: 3 },
                  },
                  {
                    ty: 'tr',
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    sk: { a: 0, k: 0, ix: 4 },
                    p: { a: 0, k: [0, 0], ix: 2 },
                    r: { a: 0, k: 0, ix: 6 },
                    sa: { a: 0, k: 0, ix: 5 },
                    o: { a: 0, k: 100, ix: 7 },
                  },
                ],
              },
              {
                ty: 'tm',
                bm: 0,
                hd: false,
                mn: 'ADBE Vector Filter - Trim',
                nm: 'Trim Paths 1',
                ix: 2,
                e: {
                  a: 1,
                  k: [
                    {
                      o: { x: 0.333, y: 0 },
                      i: { x: 0, y: 1 },
                      s: [100],
                      t: 4,
                    },
                    { s: [0], t: 22 },
                  ],
                  ix: 2,
                },
                o: { a: 0, k: 0, ix: 3 },
                s: { a: 0, k: 0, ix: 1 },
                m: 1,
              },
            ],
            ind: 5,
          },
          {
            ty: 4,
            nm: 'Layer 9 Outlines',
            sr: 1,
            st: 0,
            op: 28,
            ip: 0,
            hd: false,
            ddd: 0,
            bm: 0,
            hasMask: false,
            ao: 0,
            ks: {
              a: { a: 0, k: [35.5, 6, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 },
              sk: { a: 0, k: 0 },
              p: { a: 0, k: [541, 292, 0], ix: 2 },
              r: { a: 0, k: 0, ix: 10 },
              sa: { a: 0, k: 0 },
              o: { a: 0, k: 100, ix: 11 },
            },
            ef: [],
            shapes: [
              {
                ty: 'gr',
                bm: 0,
                hd: false,
                mn: 'ADBE Vector Group',
                nm: 'Group 1',
                ix: 1,
                cix: 2,
                np: 2,
                it: [
                  {
                    ty: 'sh',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Shape - Group',
                    nm: 'Path 1',
                    ix: 1,
                    d: 1,
                    ks: {
                      a: 0,
                      k: {
                        c: false,
                        i: [
                          [0, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                        ],
                        v: [
                          [6, 6],
                          [65, 6],
                        ],
                      },
                      ix: 2,
                    },
                  },
                  {
                    ty: 'st',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Graphic - Stroke',
                    nm: 'Stroke 1',
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 12, ix: 5 },
                    c: { a: 0, k: [0, 1, 0.0039], ix: 3 },
                  },
                  {
                    ty: 'tr',
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    sk: { a: 0, k: 0, ix: 4 },
                    p: { a: 0, k: [0, 0], ix: 2 },
                    r: { a: 0, k: 0, ix: 6 },
                    sa: { a: 0, k: 0, ix: 5 },
                    o: { a: 0, k: 100, ix: 7 },
                  },
                ],
              },
              {
                ty: 'tm',
                bm: 0,
                hd: false,
                mn: 'ADBE Vector Filter - Trim',
                nm: 'Trim Paths 1',
                ix: 2,
                e: { a: 0, k: 100, ix: 2 },
                o: { a: 0, k: 0, ix: 3 },
                s: {
                  a: 1,
                  k: [
                    { o: { x: 0.333, y: 0 }, i: { x: 0, y: 1 }, s: [0], t: 4 },
                    { s: [100], t: 22 },
                  ],
                  ix: 1,
                },
                m: 1,
              },
            ],
            ind: 6,
          },
          {
            ty: 4,
            nm: 'Layer 10 Outlines',
            sr: 1,
            st: 0,
            op: 28,
            ip: 0,
            hd: false,
            ddd: 0,
            bm: 0,
            hasMask: false,
            ao: 0,
            ks: {
              a: { a: 0, k: [6, 35.5, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 },
              sk: { a: 0, k: 0 },
              p: { a: 0, k: [292, 541.5, 0], ix: 2 },
              r: { a: 0, k: 0, ix: 10 },
              sa: { a: 0, k: 0 },
              o: { a: 0, k: 100, ix: 11 },
            },
            ef: [],
            shapes: [
              {
                ty: 'gr',
                bm: 0,
                hd: false,
                mn: 'ADBE Vector Group',
                nm: 'Group 1',
                ix: 1,
                cix: 2,
                np: 2,
                it: [
                  {
                    ty: 'sh',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Shape - Group',
                    nm: 'Path 1',
                    ix: 1,
                    d: 1,
                    ks: {
                      a: 0,
                      k: {
                        c: false,
                        i: [
                          [0, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                        ],
                        v: [
                          [6, 65],
                          [6, 6],
                        ],
                      },
                      ix: 2,
                    },
                  },
                  {
                    ty: 'st',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Graphic - Stroke',
                    nm: 'Stroke 1',
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 12, ix: 5 },
                    c: { a: 0, k: [0, 1, 0.0039], ix: 3 },
                  },
                  {
                    ty: 'tr',
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    sk: { a: 0, k: 0, ix: 4 },
                    p: { a: 0, k: [0, 0], ix: 2 },
                    r: { a: 0, k: 0, ix: 6 },
                    sa: { a: 0, k: 0, ix: 5 },
                    o: { a: 0, k: 100, ix: 7 },
                  },
                ],
              },
              {
                ty: 'tm',
                bm: 0,
                hd: false,
                mn: 'ADBE Vector Filter - Trim',
                nm: 'Trim Paths 1',
                ix: 2,
                e: {
                  a: 1,
                  k: [
                    {
                      o: { x: 0.333, y: 0 },
                      i: { x: 0, y: 1 },
                      s: [100],
                      t: 4,
                    },
                    { s: [0], t: 22 },
                  ],
                  ix: 2,
                },
                o: { a: 0, k: 0, ix: 3 },
                s: { a: 0, k: 0, ix: 1 },
                m: 1,
              },
            ],
            ind: 7,
          },
          {
            ty: 4,
            nm: 'Layer 11 Outlines',
            sr: 1,
            st: 0,
            op: 28,
            ip: 0,
            hd: false,
            ddd: 0,
            bm: 0,
            hasMask: false,
            ao: 0,
            ks: {
              a: { a: 0, k: [6, 35.5, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 },
              sk: { a: 0, k: 0 },
              p: { a: 0, k: [291.5, 43, 0], ix: 2 },
              r: { a: 0, k: 0, ix: 10 },
              sa: { a: 0, k: 0 },
              o: { a: 0, k: 100, ix: 11 },
            },
            ef: [],
            shapes: [
              {
                ty: 'gr',
                bm: 0,
                hd: false,
                mn: 'ADBE Vector Group',
                nm: 'Group 1',
                ix: 1,
                cix: 2,
                np: 2,
                it: [
                  {
                    ty: 'sh',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Shape - Group',
                    nm: 'Path 1',
                    ix: 1,
                    d: 1,
                    ks: {
                      a: 0,
                      k: {
                        c: false,
                        i: [
                          [0, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                        ],
                        v: [
                          [6, 65],
                          [6, 6],
                        ],
                      },
                      ix: 2,
                    },
                  },
                  {
                    ty: 'st',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Graphic - Stroke',
                    nm: 'Stroke 1',
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 12, ix: 5 },
                    c: { a: 0, k: [0, 1, 0.0039], ix: 3 },
                  },
                  {
                    ty: 'tr',
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    sk: { a: 0, k: 0, ix: 4 },
                    p: { a: 0, k: [0, 0], ix: 2 },
                    r: { a: 0, k: 0, ix: 6 },
                    sa: { a: 0, k: 0, ix: 5 },
                    o: { a: 0, k: 100, ix: 7 },
                  },
                ],
              },
              {
                ty: 'tm',
                bm: 0,
                hd: false,
                mn: 'ADBE Vector Filter - Trim',
                nm: 'Trim Paths 1',
                ix: 2,
                e: { a: 0, k: 100, ix: 2 },
                o: { a: 0, k: 0, ix: 3 },
                s: {
                  a: 1,
                  k: [
                    { o: { x: 0.333, y: 0 }, i: { x: 0, y: 1 }, s: [0], t: 4 },
                    { s: [100], t: 22 },
                  ],
                  ix: 1,
                },
                m: 1,
              },
            ],
            ind: 8,
          },
        ],
      },
    ],
  };

  if (hexColor) {
    const hexToRgb = hexToRgbString(hexColor);
    if (hexToRgb) {
      let jsonString = JSON.stringify(json);
      jsonString = jsonString.replaceAll(BASE_COLOR_TEXT, hexToRgb);
      return JSON.parse(jsonString);
    }
  }
  return json;
};

const hexToRgbString = (hexColor: string) => {
  const split = hexColor
    .replace(
      /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
      (m, r, g, b) => '#' + r + r + g + g + b + b,
    )
    .substring(1);

  if (split) {
    const rgbArr = split.match(/.{2}/g)?.map((value) => {
      const colorValue = parseInt(value, 16) / 255;
      if (colorValue === 0) return 0;
      return colorValue.toFixed(2);
    });

    if (Array.isArray(rgbArr)) {
      return rgbArr.join(',');
    }
  }

  return;
};
